module.exports = __webpack_public_path__ + "static/media/programmer.b0318a42.svg";